import {SoiPeeringConfig, TrunkingSite} from "../../app/types";
import {FormSection} from "../../common/components/SectionedForm";
import {useTranslation} from "react-i18next";
import React, {ReactNode, useCallback} from "react";
import {api} from "../../common/api";
import {useFetchData} from "../../common/servercall/useFetchData";
import {LabelValues, LabelValueType} from "../../common/components/LabelValues";
import {Settings} from "@mui/icons-material";
import PaperStack from "../../common/form/PaperStack";
import FormGroup from "../../common/form/FormGroup";
import axios from "axios";

export const useSoiPeeringConfigSection = (trunkingSite: TrunkingSite | undefined) : FormSection<SoiPeeringConfig> => {
    const { t } = useTranslation()

    const fetchConfig = useCallback(
        async (productId: string | undefined): Promise<SoiPeeringConfig | undefined> => {
            if (!productId) return
            const { data } = await api.get<SoiPeeringConfig>(`/api/trunking/site/${productId}/soi-peering-config`)
            return data
        },
        []
    )
    const { data, isFetching, error, refetch } = useFetchData<SoiPeeringConfig>(
        useCallback(() => fetchConfig(trunkingSite?.productId), [fetchConfig, trunkingSite?.productId])
    )

    const sipLabelValues = useCallback(
        (value: SoiPeeringConfig): LabelValueType[] => {
            return [
                { label: t('trunking-sites.sip-outbound-proxy'), value: <>{value.sipoutboundProxy}</> },
                { label: t('trunking-sites.sip-server-domain'), value: <>{value.sipserverDomain}</> },
                { label: t('trunking-sites.send-continuous-options-message'), value: <>{value.sendContinuousOptionsMessage ? t('general.enabled') : t('general.disabled')}</> },
                { label: t('trunking-sites.trunk-status'), value: <>{t(`trunking-sites.trunk-status-values.${ value.trunkStatus}`)}</> },
            ]}, [t]
    )

    const renderSoiPeeringConfig = useCallback(
        (soiPeeringConfig: SoiPeeringConfig): ReactNode => {
            return (
                <PaperStack>
                    <FormGroup label={t('trunking-sites.sip')} key={1} fullWidth={true}>
                        <LabelValues labelValues={sipLabelValues(soiPeeringConfig)} />
                    </FormGroup>
                    <></>
                </PaperStack>
            )
        },
        [sipLabelValues, t]
    )

    return {
        title: t('trunking-sites.section.configuration'),
        data: data,
        isFetching: isFetching,
        error: !!error ?axios.isAxiosError(error) && error.response?.status === 404? `trunking-sites.no-trunk-defined` : error : null,
        refetch: refetch,
        renderDetails: renderSoiPeeringConfig,
        renderForm: null,
        enabled: () => true,
        icon: () => <Settings/>
    }
}